<template>
  <router-link class="block" :class="{ active: isActiveLink }" :to="link">
    <div class="inline-block clickable px-2 py-1">
      <slot />
    </div>
  </router-link>
</template>

<script>
export default {
  props: ['link'],
  computed: {
    matchedName() {
      return ((this.$router.match(this.link).matched || [])[0] || {}).name;
    },
    isActiveLink() {
      return this.matchedName === this.$route.name;
    },
  },
}
</script>

<style lang="scss" scoped>
.active {
  border-radius: 7px;
  background-color: rgba(133, 199, 211, 0.23);
}
</style>